import SpecOutStatus from '@/models/SpecOuts/SpecOutStatus';

export default class SpecOutStatusViewModel {
    name: string;
    value: SpecOutStatus;

    public constructor(name: string, value: SpecOutStatus) {
        this.name = name;
        this.value = value;
    }
}
